import React from 'react';
import { Loader2 } from 'lucide-react';

const MapLoading: React.FC = () => {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-800 rounded-lg">
      <div className="flex items-center gap-2">
        <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
        <span className="text-gray-600 dark:text-gray-300">Cargando mapa...</span>
      </div>
    </div>
  );
};

export default MapLoading;